var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useRef, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import apiClient from '../../services/apiClient';
import { Modal } from '../UI/Modal';
import { Button } from '../UI/Button';
import { Badge } from '../UI/Badge';
import { Card, CardContent, CardHeader, CardTitle } from '../UI/Card';
import { LoadingSpinner } from '../UI/LoadingSpinner';
import { useToast } from '../UI/Toast';
import { getFriendlyErrorMessage } from '../../lib/errorHandler';
var ClarificationModal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, questionData = _a.questionData;
    var _b = useToast(), showError = _b.showError, showWarning = _b.showWarning;
    var _c = useState({}), conversationStore = _c[0], setConversationStore = _c[1];
    var _d = useState([]), messages = _d[0], setMessages = _d[1];
    var _e = useState(''), messageInput = _e[0], setMessageInput = _e[1];
    var _f = useState(false), isLoading = _f[0], setIsLoading = _f[1];
    var _g = useState(false), isExplainingConcepts = _g[0], setIsExplainingConcepts = _g[1];
    var chatEndRef = useRef(null);
    var audioRefs = useRef({});
    var currentQuestionId = (questionData === null || questionData === void 0 ? void 0 : questionData.question_number) || 'unknown';
    // Load conversation when question changes
    useEffect(function () {
        if (currentQuestionId && isOpen) {
            var existingConversation = conversationStore[currentQuestionId] || [];
            setMessages(existingConversation);
        }
    }, [currentQuestionId, isOpen, conversationStore]);
    // Scroll to bottom when messages change
    useEffect(function () {
        if (chatEndRef.current) {
            chatEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [messages]);
    // Stop audio when modal closes
    useEffect(function () {
        if (!isOpen) {
            stopAllAudio();
        }
        return function () {
            if (!isOpen) {
                stopAllAudio();
            }
        };
    }, [isOpen]);
    var stopAllAudio = function () {
        Object.values(audioRefs.current).forEach(function (ref) {
            if (ref) {
                ref.pause();
                try {
                    ref.currentTime = 0;
                }
                catch (e) {
                    console.error("Error resetting audio time:", e);
                }
            }
        });
        setMessages(function (prevMessages) {
            return prevMessages.map(function (msg) {
                return msg.isPlaying ? __assign(__assign({}, msg), { isPlaying: false }) : msg;
            });
        });
    };
    var convertTextToSpeech = function (text) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, apiClient.post('/api/text-to-speech', {
                            text: text
                        })];
                case 1:
                    response = _a.sent();
                    if (response.data.audio) {
                        return [2 /*return*/, "data:audio/mp3;base64,".concat(response.data.audio)];
                    }
                    return [2 /*return*/, null];
                case 2:
                    error_1 = _a.sent();
                    console.warn('Text-to-speech not available:', error_1);
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var userMessage, updatedMessages, response, aiResponse, newAIMessage_1, newMessagesWithoutAudio, messageIndex_1, audioSrc_1, audio, audioError_1, error_2, friendlyMessage, newMessages_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    if (!messageInput.trim())
                        return [2 /*return*/];
                    userMessage = messageInput;
                    updatedMessages = __spreadArray(__spreadArray([], messages, true), [{ sender: 'user', content: userMessage }], false);
                    setMessages(updatedMessages);
                    setConversationStore(function (prev) {
                        var newStore = __assign({}, prev);
                        newStore[currentQuestionId] = updatedMessages;
                        return newStore;
                    });
                    setMessageInput('');
                    setIsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 7, 8, 9]);
                    return [4 /*yield*/, apiClient.post('/api/ask-clarification', {
                            question_text: questionData.question_text,
                            mark_scheme: questionData.mark_scheme,
                            extract: questionData.extract,
                            clarification_query: userMessage,
                            previous_messages: messages.map(function (msg) { return ({
                                role: msg.sender === 'user' ? 'user' : 'assistant',
                                content: msg.content
                            }); })
                        })];
                case 2:
                    response = _a.sent();
                    aiResponse = response.data.response;
                    newAIMessage_1 = {
                        sender: 'ai',
                        content: aiResponse,
                        isPlaying: false
                    };
                    newMessagesWithoutAudio = __spreadArray(__spreadArray([], updatedMessages, true), [newAIMessage_1], false);
                    messageIndex_1 = newMessagesWithoutAudio.length - 1;
                    setMessages(newMessagesWithoutAudio);
                    _a.label = 3;
                case 3:
                    _a.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, convertTextToSpeech(aiResponse)];
                case 4:
                    audioSrc_1 = _a.sent();
                    // Only set up audio if we got a valid audio source
                    if (audioSrc_1) {
                        audio = new Audio(audioSrc_1);
                        audioRefs.current[messageIndex_1] = audio;
                        audio.onplay = function () {
                            setMessages(function (prevMsgs) {
                                var updatedMsgs = __spreadArray([], prevMsgs, true);
                                updatedMsgs[messageIndex_1] = __assign(__assign({}, updatedMsgs[messageIndex_1]), { isPlaying: true, audioSrc: audioSrc_1 });
                                return updatedMsgs;
                            });
                        };
                        audio.onended = function () {
                            handleAudioEnded(messageIndex_1);
                        };
                        audio.onerror = function () {
                            console.error('Audio playback error');
                            handleAudioEnded(messageIndex_1);
                        };
                        setConversationStore(function (prev) {
                            var newStore = __assign({}, prev);
                            newStore[currentQuestionId] = __spreadArray(__spreadArray([], updatedMessages, true), [__assign(__assign({}, newAIMessage_1), { audioSrc: audioSrc_1, isPlaying: false })], false);
                            return newStore;
                        });
                        setMessages(function (prevMsgs) {
                            var updatedMsgs = __spreadArray([], prevMsgs, true);
                            updatedMsgs[messageIndex_1] = __assign(__assign({}, updatedMsgs[messageIndex_1]), { audioSrc: audioSrc_1, isPlaying: false });
                            return updatedMsgs;
                        });
                    }
                    return [3 /*break*/, 6];
                case 5:
                    audioError_1 = _a.sent();
                    console.error('Error with text-to-speech:', audioError_1);
                    return [3 /*break*/, 6];
                case 6: return [3 /*break*/, 9];
                case 7:
                    error_2 = _a.sent();
                    console.error('Error asking for clarification:', error_2);
                    friendlyMessage = getFriendlyErrorMessage(error_2, 'ai');
                    newMessages_1 = __spreadArray(__spreadArray([], updatedMessages, true), [{
                            sender: 'ai',
                            content: friendlyMessage
                        }], false);
                    setMessages(newMessages_1);
                    setConversationStore(function (prev) {
                        var newStore = __assign({}, prev);
                        newStore[currentQuestionId] = newMessages_1;
                        return newStore;
                    });
                    showError(friendlyMessage, {
                        label: '🔄 Try Again',
                        onClick: function () {
                            setMessageInput(userMessage);
                        }
                    });
                    return [3 /*break*/, 9];
                case 8:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    var handleExplainConcepts = function () { return __awaiter(void 0, void 0, void 0, function () {
        var conceptRequest, updatedMessages, response, conceptExplanation, newAIMessage_2, newMessagesWithoutAudio, messageIndex_2, audioSrc_2, audio, audioError_2, error_3, friendlyMessage, newMessages;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsExplainingConcepts(true);
                    conceptRequest = "Explain all the concepts and background knowledge I need to understand this question.";
                    updatedMessages = __spreadArray(__spreadArray([], messages, true), [{
                            sender: 'user',
                            content: conceptRequest,
                            isConceptExplanation: true
                        }], false);
                    setMessages(updatedMessages);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 7, 8, 9]);
                    return [4 /*yield*/, apiClient.post('/api/ask-clarification', {
                            question_text: questionData.question_text,
                            mark_scheme: questionData.mark_scheme,
                            extract: questionData.extract,
                            clarification_query: conceptRequest,
                            previous_messages: [],
                            explain_concepts: true
                        })];
                case 2:
                    response = _a.sent();
                    conceptExplanation = response.data.response;
                    newAIMessage_2 = {
                        sender: 'ai',
                        content: conceptExplanation,
                        isPlaying: false,
                        isConceptExplanation: true
                    };
                    newMessagesWithoutAudio = __spreadArray(__spreadArray([], updatedMessages, true), [newAIMessage_2], false);
                    messageIndex_2 = newMessagesWithoutAudio.length - 1;
                    setMessages(newMessagesWithoutAudio);
                    _a.label = 3;
                case 3:
                    _a.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, convertTextToSpeech(conceptExplanation)];
                case 4:
                    audioSrc_2 = _a.sent();
                    // Only set up audio if we got a valid audio source
                    if (audioSrc_2) {
                        audio = new Audio(audioSrc_2);
                        audioRefs.current[messageIndex_2] = audio;
                        audio.onplay = function () {
                            setMessages(function (prevMsgs) {
                                var updatedMsgs = __spreadArray([], prevMsgs, true);
                                updatedMsgs[messageIndex_2] = __assign(__assign({}, updatedMsgs[messageIndex_2]), { isPlaying: true, audioSrc: audioSrc_2 });
                                return updatedMsgs;
                            });
                        };
                        audio.onended = function () {
                            handleAudioEnded(messageIndex_2);
                        };
                        audio.onerror = function () {
                            console.error('Audio playback error');
                            handleAudioEnded(messageIndex_2);
                        };
                        setConversationStore(function (prev) {
                            var newStore = __assign({}, prev);
                            newStore[currentQuestionId] = __spreadArray(__spreadArray([], updatedMessages, true), [__assign(__assign({}, newAIMessage_2), { audioSrc: audioSrc_2, isPlaying: false })], false);
                            return newStore;
                        });
                        setMessages(function (prevMsgs) {
                            var updatedMsgs = __spreadArray([], prevMsgs, true);
                            updatedMsgs[messageIndex_2] = __assign(__assign({}, updatedMsgs[messageIndex_2]), { audioSrc: audioSrc_2, isPlaying: false });
                            return updatedMsgs;
                        });
                    }
                    return [3 /*break*/, 6];
                case 5:
                    audioError_2 = _a.sent();
                    console.error('Error with text-to-speech:', audioError_2);
                    return [3 /*break*/, 6];
                case 6: return [3 /*break*/, 9];
                case 7:
                    error_3 = _a.sent();
                    console.error('Error explaining concepts:', error_3);
                    friendlyMessage = getFriendlyErrorMessage(error_3, 'ai');
                    newMessages = __spreadArray(__spreadArray([], updatedMessages, true), [{
                            sender: 'ai',
                            content: friendlyMessage,
                            isConceptExplanation: true
                        }], false);
                    setMessages(newMessages);
                    showError(friendlyMessage, {
                        label: '🔄 Try Explaining Again',
                        onClick: function () { return handleExplainConcepts(); }
                    });
                    return [3 /*break*/, 9];
                case 8:
                    setIsExplainingConcepts(false);
                    return [7 /*endfinally*/];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    var toggleAudio = function (index) {
        var audio = audioRefs.current[index];
        if (!audio)
            return;
        if (audio.paused) {
            stopAllAudio();
            var playPromise = audio.play();
            if (playPromise !== undefined) {
                playPromise.then(function () {
                    setMessages(function (prevMessages) {
                        var updatedMessages = __spreadArray([], prevMessages, true);
                        updatedMessages[index] = __assign(__assign({}, updatedMessages[index]), { isPlaying: true });
                        return updatedMessages;
                    });
                }).catch(function (e) {
                    console.error("Error playing audio:", e);
                });
            }
        }
        else {
            audio.pause();
            setMessages(function (prevMessages) {
                var updatedMessages = __spreadArray([], prevMessages, true);
                updatedMessages[index] = __assign(__assign({}, updatedMessages[index]), { isPlaying: false });
                return updatedMessages;
            });
        }
    };
    var handleAudioEnded = function (index) {
        setMessages(function (prevMessages) {
            var updatedMessages = __spreadArray([], prevMessages, true);
            updatedMessages[index] = __assign(__assign({}, updatedMessages[index]), { isPlaying: false });
            return updatedMessages;
        });
    };
    var truncateText = function (text, maxLength) {
        if (maxLength === void 0) { maxLength = 100; }
        return text.length > maxLength ? "".concat(text.substring(0, maxLength), "...") : text;
    };
    var handleClose = function () {
        stopAllAudio();
        onClose();
    };
    return (_jsx(Modal, __assign({ isOpen: isOpen, onClose: handleClose, title: "Question Clarification", size: "xl" }, { children: _jsxs("div", __assign({ className: "flex h-[600px]" }, { children: [_jsx("div", __assign({ className: "w-1/3 p-6 border-r overflow-y-auto" }, { children: _jsxs(Card, __assign({ className: "h-full shadow-sm" }, { children: [_jsx(CardHeader, __assign({ className: "pb-4" }, { children: _jsxs("div", __assign({ className: "space-y-3" }, { children: [_jsxs("div", __assign({ className: "flex items-center space-x-2" }, { children: [_jsx("div", __assign({ className: "h-6 w-6 rounded-full bg-primary/10 flex items-center justify-center" }, { children: _jsx("span", __assign({ className: "text-xs font-semibold text-primary" }, { children: (questionData === null || questionData === void 0 ? void 0 : questionData.question_number) || '?' })) })), _jsx(CardTitle, __assign({ className: "text-lg" }, { children: "Question Context" }))] })), questionData && (_jsxs("div", __assign({ className: "flex items-center space-x-2" }, { children: [_jsxs(Badge, __assign({ variant: "secondary", className: "text-xs" }, { children: [questionData.total_marks, " marks"] })), questionData.difficulty && (_jsx(Badge, __assign({ variant: questionData.difficulty === 'Easy' ? 'default' :
                                                        questionData.difficulty === 'Medium' ? 'secondary' :
                                                            'destructive', className: "text-xs" }, { children: questionData.difficulty })))] })))] })) })), _jsxs(CardContent, __assign({ className: "space-y-4" }, { children: [_jsxs("div", { children: [_jsxs("h4", __assign({ className: "font-medium text-foreground mb-2 flex items-center space-x-2" }, { children: [_jsx("svg", __assign({ className: "w-4 h-4 text-primary", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24" }, { children: _jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" }) })), _jsx("span", { children: "Question" })] })), _jsx("p", __assign({ className: "text-sm text-muted-foreground" }, { children: truncateText((questionData === null || questionData === void 0 ? void 0 : questionData.question_text) || 'No question selected') }))] }), (questionData === null || questionData === void 0 ? void 0 : questionData.extract) && (_jsxs("div", { children: [_jsxs("h4", __assign({ className: "font-medium text-foreground mb-2 flex items-center space-x-2" }, { children: [_jsx("svg", __assign({ className: "w-4 h-4 text-primary", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24" }, { children: _jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" }) })), _jsx("span", { children: "Reference" })] })), _jsx("div", __assign({ className: "bg-muted/50 p-3 rounded-lg" }, { children: _jsx("p", __assign({ className: "text-sm text-muted-foreground" }, { children: truncateText(questionData.extract, 150) })) }))] })), _jsx(Button, __assign({ onClick: handleExplainConcepts, disabled: isExplainingConcepts, variant: "outline", size: "lg", className: "w-full group hover:border-secondary hover:bg-secondary/5" }, { children: isExplainingConcepts ? (_jsxs(_Fragment, { children: [_jsx(LoadingSpinner, { size: "sm" }), _jsx("span", __assign({ className: "ml-2" }, { children: "Loading..." }))] })) : (_jsxs(_Fragment, { children: [_jsx("svg", __assign({ className: "w-4 h-4 mr-2 group-hover:scale-110 transition-transform", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24" }, { children: _jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" }) })), "Explain Concepts"] })) }))] }))] })) })), _jsxs("div", __assign({ className: "w-2/3 flex flex-col" }, { children: [_jsxs("div", __assign({ className: "flex-1 p-6 overflow-y-auto" }, { children: [messages.length === 0 && (_jsx(Card, __assign({ className: "p-6 text-center" }, { children: _jsxs("div", __assign({ className: "text-muted-foreground dark:text-muted-foreground" }, { children: [_jsx("p", __assign({ className: "mb-2" }, { children: "\uD83D\uDCAC Ask for any clarification about this question" })), _jsx("p", __assign({ className: "text-sm" }, { children: "I'll help explain concepts without giving direct answers" }))] })) }))), _jsxs("div", __assign({ className: "space-y-4" }, { children: [messages.map(function (message, index) { return (_jsx("div", __assign({ className: "flex ".concat(message.sender === 'user' ? 'justify-end' : 'justify-start') }, { children: _jsxs(Card, __assign({ className: "max-w-[80%] p-4 ".concat(message.sender === 'user'
                                                    ? 'bg-gradient-to-r from-blue-500 to-purple-600 text-white'
                                                    : message.isConceptExplanation
                                                        ? 'bg-gradient-to-r from-green-50 to-emerald-50 dark:from-green-900/20 dark:to-emerald-900/20 border border-success/20 dark:border-success'
                                                        : '') }, { children: [message.isConceptExplanation && message.sender === 'user' ? (_jsx("p", __assign({ className: "text-sm font-medium" }, { children: "\uD83E\uDDE0 Requesting concept explanation..." }))) : (_jsx(ReactMarkdown, __assign({ className: "prose dark:prose-invert max-w-none text-sm" }, { children: message.content }))), message.sender === 'ai' && message.audioSrc && (_jsx("div", __assign({ className: "mt-3 flex justify-end" }, { children: _jsx(Button, __assign({ onClick: function () { return toggleAudio(index); }, variant: "secondary", size: "sm" }, { children: message.isPlaying ? '⏸️' : '▶️' })) })))] })) }), index)); }), isLoading && (_jsx("div", __assign({ className: "flex justify-start" }, { children: _jsx(Card, __assign({ className: "p-4" }, { children: _jsx(LoadingSpinner, { message: "Thinking..." }) })) })))] })), _jsx("div", { ref: chatEndRef })] })), _jsx("div", __assign({ className: "p-6 border-t border-border dark:border-border" }, { children: _jsxs("form", __assign({ onSubmit: handleSubmit, className: "flex space-x-3" }, { children: [_jsx("textarea", { value: messageInput, onChange: function (e) { return setMessageInput(e.target.value); }, placeholder: "Ask for clarification...", className: "flex-1 p-3 border border-border dark:border-border rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white dark:bg-muted text-foreground dark:text-white placeholder-gray-500 dark:placeholder-gray-400", rows: 2, disabled: isLoading || isExplainingConcepts, onKeyDown: function (e) {
                                            if (e.key === 'Enter' && !e.shiftKey) {
                                                e.preventDefault();
                                                handleSubmit(e);
                                            }
                                        } }), _jsx(Button, __assign({ type: "submit", disabled: !messageInput.trim() || isLoading || isExplainingConcepts, variant: "default" }, { children: "Send" }))] })) }))] }))] })) })));
};
export default ClarificationModal;
